import { Component, OnInit, effect, inject } from '@angular/core';
import { PressReleaseService } from './servicea/press-release.service';
import { SharedSignalsService } from '../common/services/shared-signals.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PressRelease } from '../common/models/press-release.model';

@Component({
  selector: 'taly-press-release',
  templateUrl: './press-release.component.html',
  styleUrls: ['./press-release.component.scss'],
  standalone: false,
  providers: [],
})
export class PressReleaseComponent implements OnInit {
  private transferSignal = inject(SharedSignalsService);
  private pressReleaseService = inject(PressReleaseService);
  private sanitizer = inject(DomSanitizer);

  pressReleaseList: PressRelease[] = [];
  textDirection = 'ltr';

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getAllPressReleaseList();
  }

  getAllPressReleaseList(): void {
    this.pressReleaseService.getAllPressRelease().subscribe({
      next: (res: PressRelease[]) => {
        this.pressReleaseList = res;
      },
      error: (err) => {
        console.error('Error fetching press releases', err);
      },
    });
  }

  sanitizerContent(htmlContent: string | null): SafeHtml {
    if (htmlContent) {
      return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    }
    return '';
  }
}
